import { useEffect, useState } from 'react'
import { connect } from 'react-redux';
import { Alert, Breadcrumb, Button, Col, Form, Row, Card, Descriptions, Typography, Popover, Select, Input } from 'antd'
import { Check, Command, Edit, File, X } from 'react-feather'
import { withRouter, Link } from 'react-router-dom'
import { getDefaultDescription, templateRegistry, doesTemplateExist } from 'Services/ActionsPagesUtils'
import { RightOutlined } from '@ant-design/icons'
import { ActionsPage } from 'Model'
import cuid from 'cuid'
import showAutofillModal from './AutofillModal'
import ConfigItems from './ConfigItems'
{ Option } = Select
{ Text } = Typography
{ TextArea } = Input
import './Detail.scss'

Detail = ({ id, match, history, darkModeEnabled, plugins }) ->

  { params: { actionsPageId, spaceId }} = match

  [isLoading, setIsLoading] = useState(true)
  [component, setComponent] = useState(undefined)
  [services, setServices] = useState([])
  [serviceCalls, setServiceCalls] = useState([])
  [configItems, setConfigItems] = useState(undefined)
  [showMissingService, setShowMissingService] = useState(false)
  [showMissingTemplate, setShowMissingTemplate] = useState(false)
  [data, setData] = useState(undefined)

  [form] = Form.useForm()

  useEffect( ->
    ( ->
      setIsLoading(true)
      if actionsPageId is 'new'
        configNode = new ActionsPage(cuid())
        configNode.init()
        setData(configNode)
      else
        setData(await ActionsPage.load(actionsPageId))

      setServices(await Weaver.Plugin.list())
      setIsLoading(false)
    )()
    undefined
  , [])

  useEffect( ->
    ( ->
      if data? and !isLoading
        if actionsPageId is 'new'
          showAutofillModal(onReceivedConfig)
        else
          onReceivedConfig(data.toPlainObj())
    )()
    undefined
  , [data, isLoading])

  getFunctionCalls = (plugin) ->
    plugin
      .printFunctions()
      .map((signature) ->
        signature.split('(')[0]
      ).filter((name) ->
        [
          "getApplicationInfo",
          "getSwagger",
          "exampleFile",
          "getStatus",
          "getConfigDefinition"
        ].indexOf(name) is -1
      )

  useEffect( ->
    if component
      setShowMissingTemplate(!doesTemplateExist(component))
    else
      setShowMissingTemplate(false)
    undefined
  , [component])

  onReceivedConfig = (conf) ->
    form.setFieldsValue(conf)
    await setService(conf.serviceName)
    setCall(conf.serviceCall)
    setComponent(conf.component)

  templateDescriptionsBlock = (
    <Descriptions bordered column={1} title="Template" size="middle">
      <Descriptions.Item label="Template">
        <Form.Item name="component">
          <Select onSelect={(val) -> setComponent(val)}>
            {templateRegistry.map((component) ->
              <Option value={component} key={component}> { _.startCase(component) }</Option>
            )}
          </Select>
        </Form.Item>
      </Descriptions.Item>
      <Descriptions.Item label="Description">
        <Form.Item name="description">
          <TextArea />
        </Form.Item>
      </Descriptions.Item>
    </Descriptions>
  )

  setService = (service) ->
    if service?
      try
        plugin = plugins[service]
        setShowMissingService(false)
        setServiceCalls(getFunctionCalls(plugin))
      catch
        setShowMissingService(true)

  getConfigItems = (fnSignature) ->
    if fnSignature.parameters?
      [{
        description: fnSignature.parameters[0].description
        explode: fnSignature.parameters[0].explode
        in: fnSignature.parameters[0].in
        name: fnSignature.parameters[0].name
        required: fnSignature.parameters[0].required
        type: fnSignature.parameters[0].schema.type
      }]
    else if fnSignature.requestBody?
      schema = fnSignature.requestBody.content['multipart/form-data'].schema
      _.map(schema.properties, (val, key) -> {
        val...,
        name: key
        required: schema.required.includes(key)
        value: data.get('parameters')?[key]
      })

  setCall = (signature) ->
    fnSignature = services.find((service) ->
      service.getPluginName() is form.getFieldValue('serviceName')
    ).getFunctionSignature(signature)
    configItems = getConfigItems(fnSignature)
    setConfigItems(configItems)

  serviceDescriptionsBlock = (
    <Descriptions title="Service" bordered style={{ marginTop: 25 }} column={1}>
        <Descriptions.Item label="Service name">
          <Form.Item name="serviceName">
            <Select
              onSelect={(service) ->
                setService(service)
                form.setFieldsValue({ serviceCall: undefined })
              }
            >
              {services.map((plugin) ->
                name = plugin.getPluginName()
                <Option value={name} key={name}> { _.startCase(name) }</Option>
              )}
            </Select>
          </Form.Item>
        </Descriptions.Item>
        <Descriptions.Item label="Function call">
          <Form.Item name="serviceCall">
            <Select
              options={
                serviceCalls.map((val) -> { label: val, value: val })
                            .filter((option) -> option.value isnt 'importExcel')
              }
              onSelect={setCall}
            />
          </Form.Item>
        </Descriptions.Item>
      </Descriptions>
  )

  handleEmptyParamVals = (params) ->
    _.map(params, (val, key) -> if val is "" then params[key] = undefined)
    params

  onFinish = ({
    component,
    description,
    serviceCall,
    serviceName,
    title,
    parameters...
  }) ->
    _.map({ component, description, serviceCall, serviceName, title }, (val, key) ->
      data.set(key, val) if val
    )

    cleanedParams = handleEmptyParamVals(parameters) if parameters
    data.set('parameters', cleanedParams, { dataType: 'json' }) if cleanedParams
    try
      data.unset('service')
    await data.save({ commitMessage: "Configure Service." })
    history.goBack()

  if data
    <Form form={form} onFinish={onFinish}>
      <Breadcrumb style={{ margin: 20, marginBottom: 0 }}>
        <Breadcrumb.Item>
          { Weaver.getInstance().currentProject()?.name() }
        </Breadcrumb.Item>
        <Breadcrumb.Item>
          <Link to="/#{ spaceId }/settings/services">
            Services
          </Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item>
          { actionsPageId }
        </Breadcrumb.Item>
      </Breadcrumb>
      <Card
        actions={[
          <Button htmlType="submit" type="link" icon={<Check />} />,
          <X onClick={history.goBack} />
        ]}
        className="actions-pages-detail-container"
        title={
          <Row align="middle" gutter={16}>
            <Col><Command /></Col>
            <Col flex={1}>
              <Form.Item name="title">
                <Input />
              </Form.Item>
            </Col>
          </Row>}
        style={{ margin: 25, borderRadius: '1rem' }}
      >
        { showMissingTemplate && <Alert style={{ marginBottom: 20 }} message="No template was found which matches \"#{ component }\". If you're looking for a hidden template, be sure to type the namespace correctly e.g. \"organisation/template\"." type="error" /> }

        { templateDescriptionsBlock }

        { showMissingService && <Alert style={{ marginTop: 20 }} message="No Weaver.Plugin is installed which matches this service. Contact us to learn more about how to set this up." type="error" /> }

        { serviceDescriptionsBlock }

        {if configItems?
          <ConfigItems
            accessor={[configItems, setConfigItems]}
            form={form}
            template={component}
            darkModeEnabled={darkModeEnabled}
          />
        }
      </Card>
    </Form>
  else
    null

mapStateToProps = ({ explore: { darkModeEnabled, plugins }}) -> { darkModeEnabled, plugins }
export default connect(mapStateToProps)(withRouter(Detail))
